module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flash-back-video.f79c56c8.jpg";